<template>
    <g style="color: #fff;">
    
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1 5C4 5 6 4 10 1C14 4 16 5 19 5C19 19 10 21 10 21C10 21 1 19 1 5Z"
            stroke="#00BA88"
            stroke-width="2"
            stroke-linejoin="round"
        />
        <path
            d="M7 11L9 13L13 9"
            stroke="#00BA88"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />

    </g>
</template>

<script>
export default {
    props: {
        colour: {
            type: String,
            default: "currentColor"
        }
    }
};
</script>
